import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";
import { Mail } from "@material-ui/icons";
import * as APIStore from "../../store/APIStore";

const ProgramAdministrator = (props: any) => {
    let { patientEncounterId } = props;
    let contact: APIStore.HNIProviderContact = props.ProviderContact;
    const history = useHistory();

    let { type, displayName, email } = contact;

    const handleNameClick = (email: string) => {
        history.push("/compose-new-message-admin", { receiverId: 'programmanagers@hnihc.com', patientEncounterId: patientEncounterId });
    };

    return (
        <React.Fragment>
            <Button title="Program Manager" color="primary"
                onClick={() => {
                    handleNameClick(email);
                }}
                startIcon={<Mail />}>
                Contact Program Manager
            </Button>
        </React.Fragment>

    );
};

export default ProgramAdministrator;